import './scripts/main';
import './styles/main.scss';

import './images/common/contact-noimage-thumb.jpg';

import './images/courses-nav.png';
import './images/courses-nav-mobile.png';

import './images/zoom_landing_header.jpg';
import './images/zoom_landing_footer.jpg';
import './images/zoom_landing_laptop.png';
import './images/zoom_landing_mobile-1.png';
import './images/zoom_landing_mobile-2.png';
import './images/zoom_landing_mobile-3.png';

import './images/landing/schools-adwords-hero.png';

import './images/email/edm_social_facebook_x28.png';
import './images/email/edm_social_instagram_x28.png';
import './images/email/edm_social_website_x28.png';
import './images/email/edm_triple_header.jpg';
import './images/email/edm_laptop_portal.png';

import './images/social-media-icons/fb.jpg';
import './images/social-media-icons/insta.jpg';
import './images/social-media-icons/li.jpg';
import './images/social-media-icons/rss.jpg';
import './images/social-media-icons/twitter.jpg';
import './images/social-media-icons/website.jpg';
import './images/social-media-icons/youtube.jpg';



// WEBPACK FOOTER //
// ./vively/index.js